// axios boot file (src/boot/axios.js)

import Vue from 'vue';
import axios from 'axios';

let apiUrl = 'https://app.travellyze.com';

try {
  apiUrl = process.env.BACKEND_URL.replace(/"/g, '');
} catch (e) {}

// We create our own axios instance and set a custom base URL.
// Note that if we wouldn't set any config here we do not need
// a named export, as we could just `import axios from 'axios'`
const api = axios.create({
  baseURL: apiUrl
});
const apiV2 = axios.create({
  baseURL: process.env.V2_BACKEND_URL.replace(/"/g, '')
});

// for use inside Vue files through this.$axios and this.$api
Vue.prototype.$axios = axios;
Vue.prototype.$api = api;

// Here we define a named export
// that we can later use inside .js files:
export { axios, api, apiV2 };
